import { filter, map } from 'rxjs';

import { HisSearchService } from '../service/his-search.service';
import { HisWidgetUtils } from '../utils/his-widget-utils';
import { HisWidgetBaseSelect } from './his-widget-base-select';
import { HisSearch, HisSearchCriteria, HisSearchGroup } from './search/his-search';

/**
 * Search select values can have any kind of attributes. Even the id attribute is not required
 * if the component obtains the input selectedOptionsIdColumn.
 */
export class HisSearchSelectWidget extends HisWidgetBaseSelect<any[]> {
    kind = 'search-select';
    // the name of the search entity
    searchEntity: string;
    searchConfigFile: string;
    selectedOptionsIdColumn: string;
    selectedOptionsLabelColumn: string;
    showSearchFilter = true;

    constructor( private searchService: HisSearchService, options: any = {} ) {
        super( options );

        this.kind = options.kind || 'search-select';
        this.searchEntity = options.searchEntity;
        this.searchConfigFile = options.searchConfigFile;
        this.selectedOptionsIdColumn = options.selectedOptionsIdColumn;
        this.selectedOptionsLabelColumn = options.selectedOptionsLabelColumn;
        this.showSearchFilter = options.showSearchFilter;
    }

    protected doPresetInputFields( presetValue: any, onPresetSuccess: () => void ): void {
        console.log( 'presetting search-select field', this.id, 'to', presetValue );
        console.log( 'selectedOptionsIdColumn =', this.selectedOptionsIdColumn );
        console.log( 'this.selectedOptionsLabelColumn =', this.selectedOptionsLabelColumn );

        this.value = [];
        this.originalValue = [];

        if ( !presetValue ) {
            return;
        }

        // The preset value of a search select is a list of id values.
        // So to obtain all other attributes we must run a search with the id's as the unique search constraint.
        this.getWidgetValues( presetValue ).subscribe( ( values: any[] ) => {
            if ( Array.isArray( values ) && values.length > 0 ) {
                values.forEach( value => this.value.push( value ) );
                this.originalValue = [...this.value];

                onPresetSuccess();
            }
        } );
    }

    public getWidgetValueDetail( idsStr: string ) {
        // Use value as search constraint
        const ids = HisWidgetUtils.parseArrayString( idsStr );
        const search = this.prepareSearch( ids );
        console.log( 'search =', search );
        return this.searchService.loadSearchResult( search, 0, null ).pipe(
            filter( result => !!result ),
            map( searchResult => {
                console.warn( searchResult );
                console.warn( this.selectedOptionsIdColumn );
                console.log( 'Preset data for his-search-select \'' + searchResult.name
                    + '\' (' + searchResult.offset + '/' + searchResult.limit + '/'
                    + searchResult.totalCount + ') loaded.' );

                const rows = searchResult.data;
                console.log( 'preset search result =', rows );

                const value = rows.map( row => {
                    const id = row.get( this.selectedOptionsIdColumn );
                    const label = row.getAt( 0 );
                    const flatRow = row.toFlatSearchResultRow( id, label );
                    console.log( 'Found preset data flatRow =', flatRow );
                    return flatRow;
                } );

                return { value, hasUnresolvedId: value.length != ids.length };
            } )
        );
    }

    private prepareSearch( ids: string[] ): HisSearch {
        const criteria = new HisSearchCriteria();
        criteria.field = this.selectedOptionsIdColumn;
        criteria.value = ids.join( ',' );

        const group = new HisSearchGroup();
        group.groupLabel = this.group;
        group.criteria.push( criteria );

        const search = new HisSearch();
        search.configFile = this.searchConfigFile;
        search.groups.push( group );
        return search;
    }
}
